<template>
  <!-- 联系我们 -->
  <div>
    <div class="main">
      <div class="breadcrumb">
        <span>首页</span>
        <span>></span>
        <span>联系我们</span>
      </div>
      <div class="main-content">
        <div class="content-l">
          <div class="privacy">
            <!-- 公告 -->
            <div class="notice" v-if =" publicityData == undefined ? false : true">
              <h1 style="text-align:center;margin:20px;" >{{publicityData.title}}</h1>
              <div v-html="publicityData.content" class="publicity"></div>
              <p style="text-align:right">
                {{publicityData.footerTitle}}
              </p>
              <p style="text-align:right">
                {{publicityData.startDate}}
              </p> 
              <div style="border-bottom:1px solid #eee;margin:20px;"></div>
            </div>  

            <!-- <div class="notice">
              <h1 style="text-align:center;margin:20px;" >公示</h1>
              <p>
                根据《上海市新闻出版局关于开展2023年度新闻记者证核验工作的通知》沪新出 [2024]1号，现将我单位拟通过年度核验人员公示如下：
              </p>
              <p>
                陈锐、孟佳丽、沈从乐、施歌、文思敏、吴洋洋、许诗雨、赵嘉
              </p>
              <p>
                公示时间：2024年2月20日—2024年3月1日
              </p>
              <p>
                监督举报电话：上海市新闻出版局 021-64339117，《第一财经》杂志 021-22005899
              </p>
              <p style="text-align:right">
                《第一财经》杂志
              </p>
              <p style="text-align:right">
                2024年2月20日
              </p>
              <div style="border-bottom:1px solid #eee;margin:20px;"></div>
            </div>   -->

            <!-- 联系我们 -->
            <div class="contact">
              <p>联系我们</p>
              <p>社址 Address</p>
              <p>上海市静安区南京西路651号广电大厦东临楼(200041)</p>
              <p>电话 Tel 021-22005899</p>
              <p>传真 Fax 021-22004378（采编）</p>
              <p>北京运营中心 Beijing Bureau</p>
              <p>北京市朝阳区光华路2号阳光100G座西侧2层(100026)</p>
              <p>电话 Tel 010-65925709</p>
              <p>传真 Fax 010-65925018</p>
              <p>发行客服（纸杂志）</p>
              <p>4006060101转4（工作日9:00-17:00）</p>
              <p>电子杂志客服</p>
              <p>E-mail：zhoukankf@cbnweek.com</p>
              <p>
                （iPad、iPhone、安卓、网页等电子杂志的订阅、续订、阅读等问题，请发送邮件到本邮箱）
              </p>
              <p>
                电子杂志客服电话：400-606-0101 加拨5 （工作日9：30——17：30）
              </p>
            </div>
          </div>
        </div>

        <div class="content-r">
          <Wechart></Wechart>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Wechart from "@/components/wechart";
import { getTdkList,getPublicity} from "@/api/tdk";
export default {
  components: {
    Wechart
  },
  data() {
    return {
      publicityData:undefined
    };
  },
  created() {
    getTdkList({column:0}).then(res => {
      const head = document.getElementsByTagName('head')
      const meta = document.createElement('meta')
      document.title= res.data.data[0].title;
      document.querySelector('meta[name="keywords"]').setAttribute('content',res.data.data[0].keyword)
      document.querySelector('meta[name="description"]').setAttribute('content', res.data.data[0].describe)
      head[0].appendChild(meta)
    })
    getPublicity().then(res =>{
      this.publicityData = res.data.data;
    })
  }
};
</script>
<style lang="scss" scoped>
.breadcrumb {
  color: #999999;
  font-size: 14px;
  line-height: 20px;
  padding-top: 20px;
  padding-bottom: 16px;
  span:last-child {
    color: #0091ff;
  }
}
.privacy {
  padding: 30px;
  background: #ffffff;
  margin-bottom: 60px;
  text-align: justify;
  p {
    font-size: 16px;
    margin-bottom: 10px;
    line-height: 32px;
    text-indent: 2em;
    padding-right: 2em;
    box-sizing: border-box;
  }
  p:first-child {
    font-weight: bold;
  }
}
/deep/ .publicity{
    p {
      font-size: 16px;
      margin-bottom: 10px;
      line-height: 32px;
      text-indent: 2em;
      padding-right: 2em;
      box-sizing: border-box;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/footer/contact.vue